export const generateSubject = (customText: string): string => {
  return customText;
};


export const generateHtml = (customBody: string, firstname?: string, lastname?: string): string => {
  const greeting = firstname && lastname ? `Dear ${firstname} ${lastname},` : (firstname ? `Dear ${firstname},` : (lastname ? `Dear ${lastname},` : ''));

  return `${greeting} ${customBody}`;
};